import React, { Component } from 'react';

import styles from './styles.less';

interface Props {
	currentPageIndex: number;
	children: React.ReactNode;
}

export default class Pager extends Component<Props> {
	static defaultProps = {
		currentPageIndex: 0,
	};

	render() {
		const { currentPageIndex, children } = this.props;

		return (
			<div className={styles.pager}>
				{React.Children.map(children, (page, pageIndex) =>
					React.cloneElement(page as React.ReactElement, {
						currentPageIndex,
						pageIndex,
					})
				)}
			</div>
		);
	}
}
